'use client';

import LucideCustom from '@/components/custom-lucide/lucide-custom';
import { SidebarItemProps } from '@/hooks/use-sidebar-store';
import { AllSubKeysMessageResource } from '@/i18n/messages';
import { cn } from '@/lib/utils';
import { Link } from '@/navigation';
import { useTranslations } from 'next-intl';
import { Fragment } from 'react';
import { CustomLayoutIcon } from './custom-layout-icon';

export function CustomBreadcrumbResponsive({
    className,
    items,
}: {
    className?: string;
    items: SidebarItemProps[];
}) {
    const transSidebar = useTranslations('Sidebar');

    if (items.length == 0) {
        return <></>;
    }

    return (
        <ul
            className={cn(
                'flex items-center gap-x-1 rounded-tl-md text-sm',
                className
            )}
        >
            {items.map((item, index, arr) => (
                <Fragment key={index}>
                    <li className='flex w-fit items-center gap-x-1 last:font-semibold'>
                        {item.href ? (
                            <Link
                                className={cn('line-clamp-1 hover:underline', {
                                    'flex items-center gap-1': !!(
                                        item._showIcon && item.icon
                                    ),
                                })}
                                href={item.href}
                            >
                                {item._showIcon && item.icon && (
                                    <CustomLayoutIcon {...item.icon} />
                                )}
                                {item.appLanguageResourceCode
                                    ? transSidebar(
                                          item.appLanguageResourceCode as AllSubKeysMessageResource<'Sidebar'>
                                      )
                                    : item.name}
                            </Link>
                        ) : (
                            <div
                                className={cn(
                                    'line-clamp-1 cursor-default hover:underline',
                                    {
                                        'flex items-center gap-1': !!(
                                            item._showIcon && item.icon
                                        ),
                                    }
                                )}
                            >
                                {item._showIcon && item.icon && (
                                    <CustomLayoutIcon {...item.icon} />
                                )}
                                {item.appLanguageResourceCode
                                    ? transSidebar(
                                          item.appLanguageResourceCode as AllSubKeysMessageResource<'Sidebar'>
                                      )
                                    : item.name}
                            </div>
                        )}
                    </li>
                    {items.length - index != 1 && (
                        <div>
                            <LucideCustom iconName={'Slash'} />
                        </div>
                    )}
                </Fragment>
            ))}
        </ul>
    );
}
